"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the same value as the given argument.
 *
 * @example
 * ```ts
 * identity(5); // 5
 * ```
 */
function identity(a) {
    return a;
}
exports.default = identity;
//# sourceMappingURL=identity.js.map